module.exports = __webpack_public_path__ + "static/logo-0d9769c047dc081e5bb5fc21ae5f3e53.png";